export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/c04ff536c9a2193229ad97fe169cf10c.svg";